module.exports = __webpack_public_path__ + "img/qrcode.ed9446b7.png";